<template>
  <nav>
    <div v-if="isMobile" class="Header">
      <PageHeader 
      title="FREE Competitive Estimates!" 
      titleTwo='Ask About our 50 Year Warranty!'
      />
    </div>
  <div class="mobileContent">
    <div @click="showMenu = !showMenu" class="hamburger">
      <span :class="{ rotate: showMenu }"></span>
      <span :class="{ translate: showMenu }"></span>
      <span :class="{ rotateNeg: showMenu }"></span>
    </div>

    <div v-if="!isMobile" class="freeQuotes">
        <p>Southwest Michigan Location - <a class="top-call-button" href="#" @click.prevent="showPhoneModal = true">269-262-5055</a></p>
        <p class="WarrantyMsg">Ask About our 50 Year Warranty! </p>
    </div>

    <div class="Logo-Container">
      <router-link to="/" @click="showMenu = false">
        <img class="Homes-Logo" :src="Logo" alt="homes roofing logo" width="100" height="100" decoding="async" fetchpriority="high">
      </router-link>
    </div>

    <div v-if="!isMobile" class="freeQuotes">
          <p>Northern Michigan Location - <a class="top-call-button" href="#" @click.prevent="showPhoneModal = true">989-858-3559</a></p>
          <p class="financing">Now offering Financing on purchases over $3000</p>
    </div>
    
    <div class="Socials">
      <a href="https://www.facebook.com/profile.php?id=100091999461722" target="_blank" rel="noopener"><img :src="Facebook" alt="Facebook" width="28" height="28" loading="lazy" decoding="async"></a>

    </div>

  </div>
  </nav>
  
  <PhoneModal v-if="showPhoneModal" @close="showPhoneModal = false" />
  <div v-if="showMenu" class="mobile-menu">
    <div class="mobileMenuContainer">
      <!-- Navigation Links -->
      <nav class="mobile-nav">
        <!-- Yellow Divider at top -->
        <div class="nav-divider"></div>
        
        <!-- Main Pages Section -->
        <div class="main-pages-row">
          <router-link to="/" @click="showMenu = false" class="nav-link">
            <span class="nav-icon">🏠</span>
            <span>Home</span>
            <span class="nav-arrow">→</span>
          </router-link>
          
          <router-link to="/about" @click="showMenu = false" class="nav-link">
            <span class="nav-icon">ℹ️</span>
            <span>About Us & FAQ</span>
            <span class="nav-arrow">→</span>
          </router-link>
        </div>
        
        <!-- Yellow Divider -->
        <div class="nav-divider"></div>
        
        <!-- Photo Gallery Section -->
        <div class="nav-section gallery-section">
          <h3 class="nav-section-title">Photo Gallery</h3>
          
          <div class="gallery-links-grid">
            <router-link to="/roofing-projects" @click="showMenu = false" class="gallery-nav-link">
              <span class="nav-icon">🏗️</span>
              <span>Roofing Projects</span>
              <span class="nav-arrow">→</span>
            </router-link>
            <router-link to="/fascia-soffit" @click="showMenu = false" class="gallery-nav-link">
              <span class="nav-icon">🔨</span>
              <span>Fascia & Soffit</span>
              <span class="nav-arrow">→</span>
            </router-link>
            <router-link to="/repair-projects" @click="showMenu = false" class="gallery-nav-link">
              <span class="nav-icon">🔧</span>
              <span>Repairs</span>
              <span class="nav-arrow">→</span>
            </router-link>
            <router-link to="/gutter-services" @click="showMenu = false" class="gallery-nav-link">
              <span class="nav-icon">🌧️</span>
              <span>Gutters</span>
              <span class="nav-arrow">→</span>
            </router-link>
            <router-link to="/siding-services" @click="showMenu = false" class="gallery-nav-link">
              <span class="nav-icon">🏡</span>
              <span>Siding</span>
              <span class="nav-arrow">→</span>
            </router-link>
          </div>
        </div>

        <!-- Yellow Divider -->
        <div class="nav-divider"></div>

        <!-- CTA Section -->
        <div class="mobile-cta-buttons">
          <h3 class="cta-section-title">Get Started Today</h3>
          <ContactForm />
        </div>

        <!-- Yellow Divider -->
        <div class="nav-divider"></div>

        <!-- Footer -->
        <div class="footer">
          <PageFooter/>
        </div>
      </nav>
    </div>
  </div>

</template>
  
  <script>
 import PageFooter from '@/components/PageFooter.vue';
 import PageHeader from '@/components/PageHeader.vue';
 import ContactForm from '@/components/ContactForm.vue';
 import PhoneModal from '@/components/PhoneModal.vue';
  export default {

    name: 'NavBar',
    data() {
        return {
            Logo: require('@/assets/HomesLogoNew.jpeg'),
            Facebook: require('@/assets/Logos/Facebook.png'),
            showMenu: false,
            isMobile: false,
            showPhoneModal: false,
        }
    },
    components: {
      PageFooter,
      PageHeader,
      ContactForm,
      PhoneModal
    },
    created() {
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkMobile);
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth <= 1024;
        }
    },
    watch: {
        showMenu(newVal) {
            if (newVal) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        }
    }
  }

  </script>
  
  <style scoped>

  
  nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #2c3e50;
    color: white;
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 3;
    opacity: 0.9;

    @media(max-width: 1024px){
      .mobileContent{
        top: 80px;
      }
      
    }
  }
  .Header{
    display: flex;
  }
  .freeQuotes {
  color: white; /* White text */
  padding: 2px; /* Some padding */
  text-align: center; /* Centered text */
  text-decoration-line: underline; /* Underline the text */
  border-radius: 10px; /* Rounded corners */
  font-size: 1em; /* Increase font size */
  font-weight: bold; /* Bold font */
  transition: all 0.3s ease; /* Smooth transitions */



  a {
    color: #f1c40f; /* Yellow text */
    text-decoration: none; /* Remove underline */
  
  }
  
}

.top-call-button {
  display: inline-block;
  margin-left: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: linear-gradient(135deg, #8d0808 0%, #bf1414 55%, #e04a2d 100%);
  color: #ffffff;
  letter-spacing: 0.2px;
  text-decoration: none;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.32);
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.top-call-button:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.4);
  filter: brightness(1.05);
}

.top-call-button:active {
  transform: translateY(1px) scale(0.99);
}

.top-call-button:focus-visible {
  outline: 2px solid #f1c40f;
  outline-offset: 2px;
}

@media (min-width: 1025px) {
  .top-call-button {
    padding: 4px 8px;
    border-radius: 6px;
    background: rgba(141, 8, 8, 0.9);
    border-color: rgba(255, 255, 255, 0.25);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.24);
  }

  .top-call-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 5px 12px rgba(0, 0, 0, 0.28);
    filter: brightness(1.03);
  }
}

.financing {
  font-weight: bold;
  color: #f1c40f;
  text-decoration-line: underline;
}

.WarrantyMsg{
  font-size: 1em;
  font-weight: bold;
  text-align: center;
  color: #f1c40f;
  padding: 2px;
  text-decoration-line: underline;
  border-radius: 10px;
  transition: all 0.3s ease;
}


.freeQuotes:hover {
  transform: scale(1.05); /* Slightly enlarge the div on hover */
}
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .Logo-Container {
    padding: 6px 8px;
    width: 220px;
    border-radius: 12px;
    overflow: visible;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(241, 196, 15, 0.25);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255,255,255,0.08);
    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
  }
  .Logo-Container:hover {
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.45), 0 0 0 2px rgba(241, 196, 15, 0.5);
    border-color: rgba(241, 196, 15, 0.6);
  }
  .Homes-Logo {
    width: 100%;
    height: 76px;
    object-fit: contain;
    border-radius: 8px;
    outline-style: none;
    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.4));
    transition: filter 0.25s ease;
  }
  .Logo-Container:hover .Homes-Logo {
    filter: drop-shadow(0 4px 8px rgba(241, 196, 15, 0.3));
  }

  @media (max-width: 480px) {
    .Logo-Container {
      width: 140px;
    }
    .Homes-Logo {
      height: 58px;
    }
  }

  @media (min-width: 481px) and (max-width: 768px) {
    .Logo-Container {
      width: 170px;
    }
    .Homes-Logo {
      height: 68px;
    }
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    .Logo-Container {
      width: 195px;
    }
    .Homes-Logo {
      height: 78px;
    }
  }
  .contact {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .phone {
    margin-right: 1rem;
    border: white 1px solid;
    border-radius: 5px;
    padding: 15px;
    background-color: #950d0f;
    outline: black 1px solid;
    border-color: #950d0f;
  }

  .hamburger {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    position: relative;
    cursor: pointer;
    padding: 5px;
    border-radius: 5px;
    transition: background-color 0.3s ease;
  }
  .Socials {
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .Socials img {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }
  .hamburger:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  .hamburger span {
    display: block;
    width: 25px;
    height: 3px;
    background-color: white;
    border-radius: 2px;
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    position: absolute;
  }
  .hamburger span:nth-child(1) {
    top: 8px;
  }
  .hamburger span:nth-child(2) {
    top: 16px;
  }
  .hamburger span:nth-child(3) {
    top: 24px;
  }
  /* X transformation styles */
  .hamburger span.rotate {
    top: 16px;
    transform: rotate(45deg);
    background-color: #f1c40f;
  }
  .hamburger span.rotateNeg {
    top: 16px;
    transform: rotate(-45deg);
    background-color: #f1c40f;
  }
  .hamburger span.translate {
    opacity: 0;
    transform: translateX(-20px);
  }
  .mobileContent {
    display: flex;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    background-color: #2c3e50;
    color: white;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;
    justify-content: space-between;
  }
    .mobile-menu {
      display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: fixed;
    width: 100%;
    height: calc(100% - 88px);
    background-color: #1a3a5c;
    z-index: 99;
    top: 88px;
    left: 0;
    overflow-y: auto;

    @media (max-width: 1024px) {
      top: 167px;
      height: calc(100% - 167px);
    }
  }

  .mobile-menu a {
    color: white;
    font-size: 1.2rem;
  }
  .mobile-menu a:hover {
    color: #f1c40f;
  }

.bottomMenu{
  display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    .contact-button{
      width: 50%
    }
}
.break{
 width: 100%;
 border-bottom: #8d0808 .25em solid;
}
.mobileMenuContainer{
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
}

/* CTA Section at top */
.mobile-cta {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding: 20px;
  display: flex;
  justify-content: center;
  border-bottom: 3px solid #f1c40f;
}

.mobile-cta :deep(.buttonList) {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.mobile-cta :deep(.contact-button),
.mobile-cta :deep(.financing-button) {
  width: 100%;
  padding: 15px 20px;
  font-size: 1rem;
}

/* Navigation Section Styling */
.main-pages-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  background: linear-gradient(135deg, #1e4d76 0%, #1a3a5c 100%);
}

.main-pages-row .nav-link {
  flex: 1;
  justify-content: center;
  border-right: 2px solid rgba(241, 196, 15, 0.3);
  padding: 22px 20px;
  font-size: 1.15rem;
  font-weight: 600;
  background-color: transparent;
  position: relative;
}

.main-pages-row .nav-link:last-child {
  border-right: none;
}

.main-pages-row .nav-link:hover {
  background-color: rgba(241, 196, 15, 0.15);
  transform: scale(1.02);
}

.main-pages-row .nav-link .nav-icon {
  font-size: 1.5rem;
  margin-right: 12px;
}

.main-pages-row .nav-link .nav-arrow {
  margin-left: auto;
  font-size: 1.3rem;
  opacity: 0.7;
  transition: transform 0.2s ease;
}

.main-pages-row .nav-link:hover .nav-arrow {
  transform: translateX(5px);
  opacity: 1;
  color: #f1c40f;
}

.nav-section {
  padding: 20px 0;
}

.nav-section.gallery-section {
  background-color: transparent;
  padding: 25px 0 20px 0;
}

/* Gallery Links Grid */
.gallery-links-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 10px 15px 0 15px;
}

.gallery-nav-link {
  display: flex;
  align-items: center;
  padding: 18px 15px;
  color: white;
  text-decoration: none;
  font-size: 1.05rem;
  font-weight: 500;
  transition: all 0.3s ease;
  border-radius: 8px;
  margin-bottom: 8px;
  background: linear-gradient(135deg, rgba(26, 58, 92, 0.5) 0%, rgba(22, 58, 88, 0.5) 100%);
  border: 1px solid rgba(241, 196, 15, 0.2);
  position: relative;
}

.gallery-nav-link:hover {
  background: linear-gradient(135deg, rgba(241, 196, 15, 0.15) 0%, rgba(241, 196, 15, 0.25) 100%);
  border-color: rgba(241, 196, 15, 0.6);
  transform: translateX(5px);
  box-shadow: 0 4px 12px rgba(241, 196, 15, 0.2);
}

.gallery-nav-link .nav-icon {
  font-size: 1.4rem;
  width: 40px;
  text-align: center;
  margin-right: 12px;
}

.gallery-nav-link .nav-arrow {
  margin-left: auto;
  font-size: 1.2rem;
  opacity: 0.6;
  transition: all 0.3s ease;
}

.gallery-nav-link:hover .nav-arrow {
  transform: translateX(5px);
  opacity: 1;
  color: #f1c40f;
}

/* Yellow Dividers */
.nav-divider {
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, transparent, #f1c40f 20%, #f1c40f 80%, transparent);
  box-shadow: 0 2px 8px rgba(241, 196, 15, 0.3);
}

/* Section Titles */
.nav-section-title {
  color: #f1c40f;
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding: 15px 20px 10px 20px;
  margin: 0;
  text-align: left;
  border-left: 4px solid #f1c40f;
  background: transparent;
}

.cta-section-title {
  color: #f1c40f;
  font-size: 1.2rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding: 0 0 20px 0;
  margin: 0;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* CTA Buttons at bottom of navigation */
.mobile-cta-buttons {
  background: #1a3a5c;
  padding: 30px 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.mobile-cta-buttons :deep(.buttonList) {
  display: flex !important;
  flex-direction: column !important;
  gap: 15px;
  width: 80% !important;
  max-width: 80% !important;
  padding: 0 !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
}

.mobile-cta-buttons :deep(.contact-button) {
  width: 100% !important;
  max-width: 100% !important;
  padding: 18px 24px;
  font-size: 1.2rem;
  font-weight: 600;
  background-color: #8d0808;
  color: white;
  border: none;
  border-radius: 8px;
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
  margin: 0 !important;
  box-sizing: border-box !important;
  box-shadow: 0 4px 12px rgba(141, 8, 8, 0.4);
}

.mobile-cta-buttons :deep(.contact-button):hover {
  transform: translateY(-2px);
  background-color: #a50909;
  box-shadow: 0 6px 16px rgba(141, 8, 8, 0.6);
}

.mobile-cta-buttons :deep(.financing-button) {
  width: 100% !important;
  max-width: 100% !important;
  padding: 18px 24px;
  font-size: 1.2rem;
  font-weight: 600;
  background-color: #6FACF9;
  color: white;
  border: none;
  border-radius: 8px;
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
  margin: 0 !important;
  box-sizing: border-box !important;
  box-shadow: 0 4px 12px rgba(111, 172, 249, 0.4);
}

.mobile-cta-buttons :deep(.financing-button):hover {
  transform: translateY(-2px);
  background-color: #5a9be8;
  box-shadow: 0 6px 16px rgba(111, 172, 249, 0.6);
}

/* Navigation */
.mobile-nav {
  display: flex;
  flex-direction: column;
  padding: 0;
  background-color: #1a3a5c;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 18px 20px;
  color: white;
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 500;
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.nav-link:hover, .nav-link:active {
  background-color: rgba(255, 255, 255, 0.1);
  color: #f1c40f;
}

.nav-icon {
  font-size: 1.3rem;
  width: 35px;
  text-align: center;
  margin-right: 10px;
}

.nav-arrow {
  margin-left: auto;
  color: rgba(255, 255, 255, 0.5);
  font-size: 1.2rem;
}

.nav-link:hover .nav-arrow {
  color: #f1c40f;
  transform: translateX(5px);
}

.nav-divider {
  height: 10px;
  background: linear-gradient(135deg, #002655 0%, #0a4a8a 100%);
}

.nav-section-title {
  color: #f1c40f;
  font-size: 1.15rem;
  margin: 0;
  padding: 15px 20px;
  font-weight: 600;
  background: transparent;
  border: none;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
}

.links__section {
  display: none;
}

.footer {
  margin-top: auto;
  width: 100%;
  background-color: #1a3a5c;
}

.footer :deep(.footer) {
  background: #1a3a5c !important;
  background-image: none !important;
}

    .contactUs{
      display: flex;
      flex-direction: row;
      height: 10%;
      width: 50%;
      margin: 10px;
      align-items: center;
      justify-content: space-around;
      }

  </style>